import AboutUsLeftPart from '../../components/AboutUs/AboutUsLeftPart/AboutUsLeftPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(AboutUsLeftPart);
